import { fetchData } from "../../Helpers";

export const ACTIVATION_STALE_TIME = 1000 * 60 * 5;
export const ACTIVATION_CACHE_TIME = Infinity;

export function getActivationList(
  payload = {
    // limit: 100,
    // offset: 0,
    // expired: false,
  },
) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/activation/list",
    payload,
    successCallback: () => {},
    controller: controller,
  });
}
export function getUltrainsiderActivationList(
  payload = {
    device: ["web"],
    // limit: 100,
    // offset: 0,
    // expired: false,
  },
) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/activation/ultrainsider/list",
    payload,
    successCallback: () => {},
    controller: controller,
  });
}

export function getActivationDescribe(payload, shouldThrowError) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/activation/describe",
    payload,
    successCallback: (resObj) => {
      dataLayer.push({
        event: "view_activation",
        activations: [{ ...resObj.data }],
      });
    },
    shouldThrowError,
    controller: controller,
  });
}

export function getActivationFlagList(payload) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/activation/flag/list",
    payload,
    successCallback: () => {},
    controller: controller,
  });
}

// export function getWheelStats(payload) {
//   const controller = new AbortController();
//   return fetchData({
//     endpoint: "/activation/passport/birthdayglo2025/stats",
//     payload,
//     successCallback: () => { },
//     controller: controller,
//   });
// }

export function whellSpin({ payload, successCallback }) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/activation/passport/birthdayglo2025/stats",
    payload: payload,
    successCallback: successCallback,
    controller: controller,
  });
}

export function getCalendar2024Stats() {
  const controller = new AbortController();

  return fetchData({
    endpoint: "/activation/passport/advent2024/stats",
    controller: controller,
  });
}

export function setCalendar2024Resolve(ident, successCallback, setIsLoading) {
  const controller = new AbortController();

  return fetchData({
    endpoint: "/activation/passport/advent2024/resolve",
    controller: controller,
    successCallback,
    setLoading: setIsLoading,
    payload: {
      activation: {
        ident,
      },
    },
  });
}

export function getNewyear2025Stats() {
  const controller = new AbortController();

  return fetchData({
    endpoint: "/activation/passport/newyear2025/stats",
    controller: controller,
  });
}

export async function getNewyear2025Resolve(ident, successCallback) {
  const controller = new AbortController();

  return await fetchData({
    endpoint: "/activation/passport/newyear2025/resolve",
    controller: controller,
    successCallback,
    payload: {
      activation: {
        ident,
      },
    },
  });
}

export async function getNewyear2025Redeem(ident, successCallback) {
  const controller = new AbortController();

  return await fetchData({
    endpoint: "/activation/passport/newyear2025/redeem",
    controller: controller,
    successCallback,
    payload: {
      catalogue: {
        ident,
      },
    },
  });
}

export function sendContestAnswers({
  payload,
  successCallback,
  errorCallback,
}) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/activation/contest/answer",
    payload: payload,
    successCallback: successCallback,
    errorCallback: errorCallback,
    controller: controller,
  });
}

export function getBadgeStats({ successCallback }) {
  const controller = new AbortController();

  return fetchData({
    endpoint: "/activation/passport/ultrainsider2025/stats",
    controller: controller,
    successCallback: successCallback,
  });
}

export function getSubscriptionActivationList(
  payload = {
    limit: 100,
    offset: 0,
  },
) {
  const controller = new AbortController();
  return fetchData({
    endpoint: "/subscription/activation/list",
    payload,
    successCallback: () => {},
    controller: controller,
  });
}
